/*
 * Copyright (c) Outright Mental. (https://outrightmental.com) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./BoardView.scss"
import BoardHeader from "./components/BoardHeader";
import BoardPlayer from "./components/BoardPlayer";

/**
 BoardView component
 <p>
 @return {*}
 */
export default function BoardView() {
  /**
   *
   */
  return (
    <div id="board">
      <BoardHeader/>
      <BoardPlayer playerId={0}/>
    </div>
  );
};
